export const DASHBOARD_SUCCESS = 'DASHBOARD_SUCCESS';
export const DASHBOARD_FAIL = 'DASHBOARD_FAIL';
export const DASHBOARD_REQUEST = 'DASHBOARD_REQUEST';


export const CATEGORIA_SUCCESS = 'CATEGORIA_SUCCESS';
export const CATEGORIA_FAIL = 'CATEGORIA_FAIL';
export const CATEGORIA_REQUEST = 'CATEGORIA_REQUEST';

export const UBICACION_SUCCESS = 'UBICACION_SUCCESS';
export const UBICACION_FAIL = 'UBICACION_FAIL';
export const UBICACION_REQUEST = 'UBICACION_REQUEST';

export const BAJAS_DASHBOARD_SUCCESS = 'BAJAS_DASHBOARD_SUCCESS';
export const BAJAS_DASHBOARD_FAIL = 'BAJAS_DASHBOARD_FAIL';
export const BAJAS_DASHBOARD_REQUEST = 'BAJAS_DASHBOARD_REQUEST';

export const EVOLUCION_DASHBOARD_SUCCESS = 'EVOLUCION_DASHBOARD_SUCCESS';
export const EVOLUCION_DASHBOARD_FAIL = 'EVOLUCION_DASHBOARD_FAIL';
export const EVOLUCION_DASHBOARD_REQUEST = 'EVOLUCION_DASHBOARD_REQUEST';

export const DATOS_PERSISTIDOS_SUCCESS = "DATOS_PERSISTIDOS_SUCCESS";
export const DATOS_PERSISTIDOS_FAIL = "DATOS_PERSISTIDOS_FAIL";
export const DATOS_PERSISTIDOS_REQUEST = "DATOS_PERSISTIDOS_REQUEST";

export const DEPRECIACION_DASHBOARD_REQUEST = "DEPRECIACION_DASHBOARD_REQUEST";
export const DEPRECIACION_DASHBOARD_SUCCESS = "DEPRECIACION_DASHBOARD_SUCCESS";
export const DEPRECIACION_DASHBOARD_FAIL = "DEPRECIACION_DASHBOARD_FAIL";
